import {Component} from 'react';
import '../../../../scss/common/components/_overlay.scss';
import cross from './svg/cross.svg';

const overlay = (props) => {
  const {closeOnClickOutside, className} = props;
  return WrappedComponent => (class extends Component {
    constructor(props) {
      super(props);
      this.state = {};
      this.setHeading = this.setHeading.bind(this);
    }
    
    setHeading(heading) {
      this.setState({heading});
    }
    
    render() {
      const handleOutsideClick = closeOnClickOutside ? this.props.onClose : undefined;
      return (
        <div className={`overlay ${this.props.show ? 'overlay-show' : ''} overlay-${className}`}>
          <div className="overlay_header">
            <span>{this.state.heading}</span>
            <img onClick={this.props.onClose} className="overlay_closeIcon" src={cross} />
          </div>
          <div className="overlay_content">
            <WrappedComponent {...this.props} overlay={this} />
          </div>
          <div onClick={handleOutsideClick} className="overlay_backplate" />
        </div>
      );
    }
  });
};

export default overlay;
